import { TextInput } from "@msuite/ui/form";
import { cn } from "@msuite/ui/utils";
import { datetimeOutputMiddleware, moment, timeInputMiddleware } from "@msuite/utils/date";
import type { AssignmentReferenceBookingsSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";
import {
	type BookingInputRole,
	getBookingFieldPrefix,
	submittedColumnClassName,
} from "./booking-columns";

/** Props Interface */
interface AssignmentReferenceBookingTimeInputProps {
	index: number;
	inputRole: BookingInputRole;
	timeType: "checkIn" | "checkOut";
	date: string;
	isDisabled: boolean;
}

export function AssignmentReferenceBookingTimeInput({
	index,
	inputRole,
	timeType,
	date,
	isDisabled,
}: AssignmentReferenceBookingTimeInputProps) {
	/** Context */
	const methods = useFormContext<AssignmentReferenceBookingsSchema>();
	const key = getBookingFieldPrefix(inputRole);

	/** Render */
	return (
		<div
			className={cn(
				"items-center gap-x-2 grid grid-cols-2 cursor-not-allowed",
				inputRole === "partner" && submittedColumnClassName,
			)}
		>
			<div className="input">
				<p>
					{moment(methods.getValues(`bookings.${index}.${key}${timeType}`)).format(
						"dd, DD.MM.YYYY",
					)}
				</p>
			</div>
			<TextInput
				type="time"
				control={methods.control}
				name={`bookings.${index}.${key}${timeType}`}
				label={undefined}
				placeholder={undefined}
				isRequired
				inputMiddleware={timeInputMiddleware}
				outputMiddleware={(value) => {
					const currentValue = moment(date).setTime(value);
					if (timeType === "checkIn")
						return datetimeOutputMiddleware(currentValue.postgresTimestamp());
					const currentCheckIn = moment(methods.getValues(`bookings.${index}.${key}checkIn`));
					const currentCheckOut = moment(date).setTime(value);
					if (currentCheckOut.isBefore(currentCheckIn)) {
						currentValue.add(1, "day");
					}
					return datetimeOutputMiddleware(currentValue.postgresTimestamp());
				}}
				isDisabled={isDisabled}
			/>
		</div>
	);
}
